import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private http: HttpClient) {}

  public changePassword(email: string): Observable<any> {
    let url = environment.graphQLConfig.changePasswordUrl;
    url = url.replace(':email', email);
    return this.http.get(url);
  }
}